import React from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControlLabel,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";

import logo3D from "../../assets/images/auth/aidentis_logo_3d.webp";
import aidentisLogo from "../../assets/svg/aidentis_3.svg";
import PATH from "../../helpers/PATH";

import CircleCheckbox from "./CircleCheckbox";
import {
  BrandName,
  ForgotPasswordLink,
  FormLabel,
  FormSide,
  LeftSideLink,
  LeftSideLinksContainer,
  LoginButton,
  LoginContainer,
  LoginForm,
  Logo3DImage,
  LogoSide,
  PageTitle,
  RememberForgotContainer,
  SignInWrapper,
  SignupContainer,
  SignupLink,
  StyledTextField,
} from "./newStyles";
import { useSignInForm } from "./useSignInForm";

const SignIn: React.FC = () => {
  const { formik, handleRememberMe, isRememberMe, t } = useSignInForm();
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <SignInWrapper>
      <LoginContainer>
        <LogoSide>
          <Logo3DImage alt="Aidentis Logo" src={logo3D} />
          <LeftSideLinksContainer>
            <LeftSideLink href="/app/privacy/global/terms">
              {t("common:terms") || "Пользовательское соглашение"}
            </LeftSideLink>
            <LeftSideLink href="/app/privacy/global/privacy-policy">
              {t("common:privacy-policy") || "Политика конфиденциальности"}
            </LeftSideLink>
          </LeftSideLinksContainer>
        </LogoSide>

        <FormSide>
          <LoginForm onSubmit={formik.handleSubmit}>
            <BrandName>
              <img alt="Aidentis Logo" height={14} src={aidentisLogo} />
            </BrandName>

            <PageTitle>
              {t("common:signIn", { context: "account" }) ||
                "Войдите в аккаунт"}
            </PageTitle>

            <FormLabel>{t("common:email")}</FormLabel>

            <StyledTextField
              error={formik.touched.email && !!formik.errors.email}
              helperText={(formik.touched.email && formik.errors.email) || ""}
              name="email"
              placeholder="aidentis@gmail.com"
              value={formik.values.email}
              variant="outlined"
              fullWidth
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            />

            <FormLabel>
              {t("form:validation", { context: "enterPassword" }) || "Пароль"}
            </FormLabel>

            <StyledTextField
              error={formik.touched.password && !!formik.errors.password}
              helperText={
                (formik.touched.password && formik.errors.password) || ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      edge="end"
                      onClick={handleClickShowPassword}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              name="password"
              placeholder="••••••••••••••"
              type={showPassword ? "text" : "password"}
              value={formik.values.password}
              variant="outlined"
              fullWidth
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            />

            <RememberForgotContainer>
              <FormControlLabel
                control={
                  <CircleCheckbox
                    checked={isRememberMe}
                    name="rememberMe"
                    onChange={handleRememberMe}
                  />
                }
                label={t("form:rememberMe") || "Запомнить меня"}
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "14px",
                    fontFamily: "Manrope",
                    fontWeight: 400,
                    letterSpacing: "0.06px",
                    color: "#0d0a2c",
                    marginLeft: "8px",
                  },
                  margin: 0,
                }}
              />

              <ForgotPasswordLink to={PATH.APP_FORGOT_PASSWORD}>
                {t("form:forgotPassword") || "Забыли пароль?"}
              </ForgotPasswordLink>
            </RememberForgotContainer>

            <LoginButton type="submit" variant="contained">
              {t("common:signIn") || "Войти"}
            </LoginButton>

            <SignupContainer>
              <SignupLink to={PATH.APP_SIGNUP}>
                {t("common:signUp") || "Зарегистрироваться"}
              </SignupLink>
            </SignupContainer>
          </LoginForm>
        </FormSide>
      </LoginContainer>
    </SignInWrapper>
  );
};

export default SignIn;
